import { render, staticRenderFns } from "./DownloadList.vue?vue&type=template&id=020e7070&scoped=true&"
import script from "./DownloadList.vue?vue&type=script&lang=ts&"
export * from "./DownloadList.vue?vue&type=script&lang=ts&"
import style0 from "./DownloadList.vue?vue&type=style&index=0&id=020e7070&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020e7070",
  null
  
)

export default component.exports